import React from "react";

// Pill buttons under Rigby's latest message. Tapping one sends its text as the student's reply.
export default function QuickReplies({ chips, onPick, center = false }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div className={`rg-chips${center ? " rg-chips--center" : ""}`} role="group" aria-label="Quick replies">
      {chips.map((c) => (
        <button key={c} type="button" className="rg-chip" onClick={() => onPick(c)}>
          {c}
        </button>
      ))}
    </div>
  );
}
